/*
 * Щільна таблиця реєстру з мокапа. Кеглі й висоти — з `styles/tokens.css`.
 *
 * Дві речі, яких тут раніше не було і без яких реєстр на 5 214 рядків не працює:
 * закріплена перша колонка (інакше на 768–1279 при горизонтальному скролі не видно, який
 * саме домен ти читаєш) і колонка вибору під масові дії.
 */

.wrapper {
  border: 1px solid var(--line2);
  border-radius: var(--r-lg);
  background: var(--card);
  overflow-x: auto;
}

.table {
  width: 100%;
  border-collapse: separate; /* collapse ламає межі в sticky-комірках */
  border-spacing: 0;
  font-size: var(--fs-cell);
  line-height: var(--lh-snug);
}

.th {
  text-align: left;
  height: var(--ctl-h);
  padding: 0 15px;
  background: var(--card);
  border-bottom: 1px solid var(--line2);
  font-family: 'IBM Plex Mono', monospace;
  font-size: var(--fs-micro);
  font-weight: 600;
  letter-spacing: var(--ls-label);
  text-transform: uppercase;
  color: var(--t9);
  white-space: nowrap;
}

.tr {
  height: var(--row-h);
}

.td {
  height: var(--row-h);
  padding: var(--pad-cell);
  border-bottom: 1px solid var(--line);
  background: var(--card);
  color: var(--t3);
  vertical-align: middle;
}

.tr:last-child .td {
  border-bottom: none;
}

.tr[data-clickable] {
  cursor: pointer;
}

.tr[data-clickable]:hover .td {
  background: var(--row-hover);
}

.tr[data-selected] .td {
  background: var(--active);
}

.tr[data-clickable]:focus-visible {
  outline: 2px solid var(--g);
  outline-offset: -2px;
}

/*
 * Закріплення. Ширина колонки вибору — токен, бо від неї рахується зсув наступної
 * колонки; інакше при зміні щільності перша колонка з'їде під чекбокси.
 */
.selectCell {
  position: sticky;
  left: 0;
  z-index: 2;
  width: var(--select-w);
  min-width: var(--select-w);
  padding: 0 0 0 12px;
}

.stickyCell {
  position: sticky;
  left: 0;
  z-index: 1;
}

.table[data-selectable] .stickyCell {
  left: var(--select-w);
}

/* Права межа з'являється лише коли під нею справді щось прокручено. */
.stickyCell::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 1px;
  background: var(--line2);
}

.footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--sp-4);
  padding: var(--sp-3) 15px;
  border-top: 1px solid var(--line2);
  font-family: 'IBM Plex Mono', monospace;
  font-size: var(--fs-small);
  color: var(--t9);
}

.footerCount {
  font-variant-numeric: tabular-nums;
}

.state {
  border: 1px solid var(--line2);
  border-radius: var(--r-lg);
  background: var(--card);
  padding: 40px var(--sp-6);
  display: flex;
  align-items: center;
  justify-content: center;
}

.emptyTitle {
  font-size: var(--fs-lg);
  font-weight: 600;
  line-height: var(--lh-snug);
  color: var(--t4);
}

.emptyBody {
  font-size: var(--fs-cell);
  line-height: var(--lh-base);
  color: var(--t8);
  text-align: center;
  max-width: 420px;
}

/* A failed request must look nothing like an empty table. */
.errorState {
  border: 1px solid var(--r50);
  background: var(--r16);
  border-radius: var(--r-lg);
  padding: 32px var(--sp-6);
  display: flex;
  align-items: center;
  justify-content: center;
}

.errorTitle {
  font-size: var(--fs-lg);
  font-weight: 600;
  line-height: var(--lh-snug);
  color: var(--r-txt);
}
